<template>
  <div>
    <div class="link-warp">
      <div
        :class="['link-item', { active: item.value === $route.path }]"
        v-for="item in navList"
        :key="item.value"
        @click="onClick(item.value)"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: "myTemplate",
  data() {
    return {
      navList: [
        {
          active: true,
          value: "/customer/template",
          label: "模板列表",
        },
        {
          active: false,
          value: "/customer/template/add",
          label: "添加模板",
        },
        {
          active: false,
          value: "/customer/template/default",
          label: "设置默认模板",
        },
        {
          active: false,
          value: "/customer/template/transfer",
          label: "模板过户",
        },
        {
          active: false,
          value: "/customer/template/transferlist",
          label: "模板过户记录",
        },
      ],
    };
  },
  methods: {
    onClick(val) {
      this.$router.push(val);
    },
  },
};
</script>

<style lang="less" scoped>
.link-warp {
  padding: 0 15px;
  margin-top: 20px;
  .link-item {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    padding: 0 30px;
    font-size: 16px;
    font-weight: 600;
    color: #4F5867;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    // &::before {
    //   content: "";
    //   position: absolute;
    //   bottom: -1px;
    //   width: 0;
    //   height: 2px;
    //   background-color: transparent;
    //   transition: all 0.3s;
    // }
  }
  .link-item.active {
    color: #3992e9;
    font-weight: bold;
    border: 1px solid #759DE6;
    // &::before {
    //   width: 100%;
    //   background-color: #3992e9;
    // }
  }
}
.main {
  margin: 20px 15px;
  padding: 20px;
    background: #fff;
}
</style>
